import React from "react";
import { Container, Header, Content, Grid, Row, Col, Heading, Message, HeadingGroup, Drawer, Steps, Panel, ButtonToolbar, Text, Button, Loader, RadioTile, RadioTileGroup, InputNumber, DateRangePicker, VStack, List } from 'rsuite';
import * as MapboxGeocoder from '@mapbox/mapbox-gl-geocoder';
import { Icon } from '@rsuite/icons';
import CreatableSelect from 'react-select/creatable';
import Select from 'react-select';
import NavBarComponent from "../components/NavBar";
// eslint-disable-next-line import/no-webpack-loader-syntax
import mapboxgl from '!mapbox-gl';
import MapboxDraw from "@mapbox/mapbox-gl-draw";
import CalenderSimpleIcon from '@rsuite/icons/CalenderSimple';
import ResizeIcon from '@rsuite/icons/Resize';
import ScatterIcon from '@rsuite/icons/Scatter';
import { FaExternalLinkSquareAlt } from "react-icons/fa";
import './css/businesscockpit.css'
import 'mapbox-gl/dist/mapbox-gl.css';
import 'rsuite/dist/rsuite.min.css';
import '@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css';
import '@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css'

const URL_FRONT = process.env.REACT_APP_URL_LOCAL;
const URL_BACK = process.env.REACT_APP_URL_SERVER_BACK;
mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_ACCESS_TOKEN;

const point_geojson = {
  'type': 'FeatureCollection',
  'features': [
    {
      'type': 'Feature',
      'geometry': {
        'type': 'Point',
        'coordinates': []
      }
    }
  ]
};

let current_mode = 'draw_polygon';

let draw = new MapboxDraw({
  displayControlsDefault: false,
  // Select which mapbox-gl-draw control buttons to add to the map.
  controls: {
    polygon: (current_mode === 'draw_polygon' ? true : false),
    trash: (current_mode ? true : false)
  },
  // Set mapbox-gl-draw to draw by default.
  // The user does not have to click the polygon control button first.
  defaultMode: current_mode
});

function numberWithCommas(x) {
  if (typeof x !== "undefined") {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "'");

  }
  else {
    return 0
  }
}

const { before, after, combine } = DateRangePicker;

//Business Cockpit - Upload companies
class BusinessCockpitUpload extends React.Component {

  constructor(props) {
    super(props);
    this.map = null;
    this.fileUploadRef = React.createRef();
    this.state = {
      tyle: 'mapbox://styles/mapbox/satellite-streets-v11',
      mapita: 10.5,
      zoom: 7,
      current_step: 0,
      companyNamesList: [],
      companySitesList: [],
      companyTypesList: [],
      selectedCompanyName: null,
      selectedCompanySite: null,
      selectedCompanyType: null,
      polygon_employees: 0,
      polygon_trips: 0,
      origin_geojson: '',
      isGeometrySelected: '',
      commuting_factor: 0,
      buffer_factor: 0,
      loading_state_commuterfactor: true,
      RELIS: [],
      tile_list: [],
      unique_id: '',
      enable_commuting_factor_options: false,
      change_commuting_factor: '',
      calendar_commuting_factor: [new Date('2022-11-01'), new Date('2022-11-30')],
      btnPreviousDisabled: true,
      btnNextDisabled: true,
      checkerTripsEmployees: false,
      reloadMapOnce: false,
      completeProcess: false,
      uploadedPolygonName: '',
      polygonUploadError: '',
      uploadedPolygonOptions: [],
      selectedUploadedPolygonIndex: null
    }
    this.mapContainer = React.createRef(); // Use a ref for the map container
  }

  componentDidMount() {
    this.fetchCompanyNames();
    this.fetchCompanyTypes();
    this.initializeMap();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.current_step === 4 && this.state.unique_id.length > 0 && !this.state.reloadMapOnce) {
      this.initializeMap();
    }
  }

  fetchCompanyNames() {
    fetch(URL_BACK + 'sbb_cockpit/company_names', {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })
      .then((res) => res.json())
      .then((json) => {
        let companyNames = json.map(item => ({
          value: item._id,
          label: item._id
        }));
        this.setState({ companyNamesList: companyNames });
        return companyNames;
      })
  }

  fetchCompanyTypes() {
    fetch(URL_BACK + 'sbb_cockpit/company_site_types', {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })
      .then((res) => res.json())
      .then((json) => {
        let companyTypes = json.map(item => ({
          value: item._id,
          label: item._id
        }));
        this.setState({ companyTypesList: companyTypes });
        return companyTypes;
      })
  }

  handleCompanyName(event) {
    this.setState({ selectedCompanyName: event });
    if (event !== null) {
      this.setState({ btnNextDisabled: false })
      this.fetchCompanyLocations(event.value);
    } else {
      this.setState({ btnNextDisabled: true })
    }
  }

  handleCompanySite(event) {
    console.log(event)
    this.setState({ selectedCompanySite: event });
    if (event !== null) {
      this.setState({ btnNextDisabled: false })
    }
    else {
      this.setState({ btnNextDisabled: true })
    }
  }

  fetchCompanyLocations(location) {
    fetch(URL_BACK + 'sbb_cockpit/company_sites', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        company: location
      })
    })
      .then((res) => res.json())
      .then((json) => {
        if (json.length > 0) {
          let companySites = json.map(item => ({
            value: item._id,
            label: item._id
          }));
          this.setState({ companySitesList: companySites });
          return companySites;
        } else {
          this.setState({ companySitesList: [] });
          return [];
        }
      })
  }

  handleCompanyTypes() {

    fetch(URL_BACK + 'sbb_cockpit/company_site_types', {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })
      .then((res) => res.json())
      .then((json) => {
        let companyTypes = json.map(item => ({
          value: item._id,
          label: item._id
        }));
        this.setState({ companyTypesList: companyTypes });
        return companyTypes;
      })
  }

  handleCompanyType(event) {
    if (event.length > 0) {
      this.setState({ btnNextDisabled: false })
    }
    else {
      this.setState({ btnNextDisabled: true })
    }
    this.setState({ selectedCompanyType: event });
  }

  initializeMap() {
    if (this.mapContainer.current) {
      if (this.state.current_step < 4) {
        const map = new mapboxgl.Map({
          container: this.mapContainer.current,
          style: this.state.tyle,
          center: [8.251313, 46.924143],
          zoom: this.state.zoom,
        });
        this.map = map;

        map.on('load', () => {
          // Add zoom and rotation controls to the map.
          map.addControl(new mapboxgl.NavigationControl({ showCompass: false, showZoom: false }), 'top-left');
          map.addControl(new MapboxGeocoder({ accessToken: mapboxgl.accessToken, mapboxgl: mapboxgl, marker: false }), 'top-left');
          map.addControl(draw, 'bottom-right');

          //Origin Polygon
          map.addSource('data-tiles-polygon', {
            'type': 'geojson',
            'data': '',
            'generateId': true
          });

          map.addLayer({
            'id': 'fill-tiles-polygon',
            'type': 'fill',
            'source': 'data-tiles-polygon',
            'layout': {
            },
            'paint': {
              'fill-color': '#008cff',
              'fill-opacity': 0.3
            }
          });

          map.addLayer({
            'id': 'outline-tiles-polygon',
            'type': 'line',
            'source': 'data-tiles-polygon',
            'layout': {},
            'paint': {
              'line-color': '#02569c',
              'line-width': 0.8
            }
          });
          map.addSource('point_employers', {
            'type': 'geojson',
            'data': '',
            'generateId': true
          });

          map.addLayer({
            'id': 'point_employers',
            'type': 'circle',
            'source': 'point_employers',
            'paint': {
              'circle-radius': 6,
              'circle-color': '#9c0259'
            }
          });

        });

        map.on('draw.create', (e) => {
          const data = draw.getAll();
          if (data.features.length === 1) {
            this.handlePolygonGeometryChange(data.features[0], map);
          }
        });

        map.on('draw.delete', (e) => {
          const data = draw.getAll();
          draw.deleteAll()
          if (data.features.length === 0) {
            if (this.state.current_stage === 'origin') {
              this.setState({ origin_geojson: [], isGeometrySelected: false })
            }
            //map.getSource('data-origin-polygon').setData(URL_lines);
            current_mode = 'draw_polygon'
          }
        });

        map.on('draw.update', (e) => {
          const data = draw.getAll();

          if (data.features.length === 1) {
            if (data.features[0].geometry && data.features[0].geometry.coordinates && data.features[0].geometry.coordinates.length > 0) {
              if (e.type === 'draw.update') {
                current_mode = 'default'
              }
              this.handlePolygonGeometryChange(data.features[0], map);
            }
            else {
              if (this.state.current_stage === 'origin') {
                this.setState({ origin_geojson: [], isGeometrySelected: false })
                //map.getSource('data-origin-polygon').setData(URL_lines);
              }
              current_mode = 'draw_polygon'
            }
          } else if (data.features.length === 0) {
            if (this.state.current_stage === 'origin') {
              this.setState({ origin_geojson: [], isGeometrySelected: false })
              //map.getSource('data-origin-polygon').setData(URL_lines);
            }
            current_mode = 'draw_polygon'
          }
        });

        this.setState({
          mapita: map,
          zoom: map.getZoom(),
        });
      } else {
        this.setState({ reloadMapOnce: true })
        this.map = this.state.mapita;
        const fc = draw.getAll() // returns geojson FeatureCollection

        // remove the control - removes features from map
        this.state.mapita.removeControl(draw)

        // add the feature collection to the map as a normal Layer
        this.state.mapita.addLayer({
          id: 'draw-readonly',
          type: 'fill',
          source: {
            type: 'geojson',
            data: fc
          },
          paint: {
            'fill-color': '#8202de', // blue color fill
            'fill-opacity': 0.5
          }
        })

        // Add circle 
        this.state.mapita.addSource('point', {
          'type': 'geojson',
          'data': ''
        });

        this.state.mapita.addLayer({
          'id': 'point',
          'type': 'circle',
          'source': 'point',
          'paint': {
            'circle-radius': 10,
            'circle-color': '#e32a8d' // pink color
          }
        });


        function onMove(e) {
          const coords = e.lngLat;
          // Set a UI indicator for dragging.
          this.state.mapita.getCanvas().style.cursor = 'grabbing';

          // Update the Point feature in `geojson` coordinates
          // and call setData to the source layer `point` on it.
          point_geojson.features[0].geometry.coordinates = [coords.lng, coords.lat];
          this.state.mapita.getSource('point').setData(point_geojson);
        }

        function onUp(e) {
          const coords = e.lngLat;
          // Print the coordinates of where the point had
          // finished being dragged to on the map.

          this.state.mapita.getCanvas().style.cursor = '';

          // Unbind mouse/touch events
          this.state.mapita.off('mousemove', onMove);
          this.state.mapita.off('touchmove', onMove);

          point_geojson.features[0].geometry.coordinates = [coords.lng, coords.lat];
          this.state.mapita.getSource('point').setData(point_geojson);
        }

        this.state.mapita.on('mousedown', 'point', (e) => {
          // Prevent the default map drag behavior.
          e.preventDefault();

          this.state.mapita.getCanvas().style.cursor = 'grab';

          this.state.mapita.on('mousemove', onMove);
          this.state.mapita.once('mouseup', onUp);
        });

        this.state.mapita.on('touchstart', 'point', (e) => {
          if (e.points.length !== 1) return;

          // Prevent the default map drag behavior.
          e.preventDefault();

          this.state.mapita.on('touchmove', onMove);
          this.state.mapita.once('touchend', onUp);
        });

        this.state.mapita.on('click', (event) => {
          const coords = event.lngLat;
          if (this.state.current_step === 5) {
            // Print the coordinates of where the point had
            // finished being dragged to on the map.

            this.state.mapita.getCanvas().style.cursor = '';
            // Unbind mouse/touch events
            this.state.mapita.off('mousemove', onMove);
            this.state.mapita.off('touchmove', onMove);
            this.setState({ btnNextDisabled: false })
            point_geojson.features[0].geometry.coordinates = [coords.lng, coords.lat];
            this.state.mapita.getSource('point').setData(point_geojson);
          }
        });

        this.state.mapita.setLayoutProperty('point_employers', 'visibility', 'none');
        this.state.mapita.getSource("data-tiles-polygon").setData(URL_BACK + 'sbb_cockpit/100m_heatmap_tiles/' + this.state.unique_id + '/' + this.state.buffer_factor);

      }
    }
  }

  handlePolygonUploadClick() {
    if (this.fileUploadRef.current) {
      this.fileUploadRef.current.value = '';
      this.fileUploadRef.current.click();
    }
  }

  handlePolygonFileChange(event) {
    const file = event?.target?.files ? event.target.files[0] : null;
    if (!file) {
      return;
    }

    const reader = new FileReader();

    reader.onload = (loadEvent) => {
      const fileContent = loadEvent?.target?.result;
      try {
        this.importPolygonFromGeoJSON(fileContent, file.name);
      } catch (error) {
        this.setState({
          polygonUploadError: error?.message || 'Unable to import the selected GeoJSON file.',
          uploadedPolygonName: ''
        });
      } finally {
        if (this.fileUploadRef.current) {
          this.fileUploadRef.current.value = '';
        }
      }
    };

    reader.onerror = () => {
      this.setState({
        polygonUploadError: 'Unable to read the selected file.',
        uploadedPolygonName: ''
      });
      if (this.fileUploadRef.current) {
        this.fileUploadRef.current.value = '';
      }
    };

    reader.readAsText(file);
  }

  importPolygonFromGeoJSON(fileContent, fileName) {
    if (!fileContent) {
      throw new Error('The provided file is empty.');
    }
    if (!this.state.mapita || typeof this.state.mapita.getSource !== 'function') {
      throw new Error('The map is still loading. Please try again in a moment.');
    }

    let parsedContent = null;
    try {
      parsedContent = JSON.parse(fileContent);
    } catch (error) {
      throw new Error('The selected file is not valid JSON.');
    }

    const polygonOptions = this.extractAllPolygonGeometries(parsedContent);
    if (!polygonOptions.length) {
      throw new Error('No Polygon geometry was found in the GeoJSON file.');
    }

    if (polygonOptions.length === 1) {
      this.setState({
        polygonUploadError: '',
        uploadedPolygonName: fileName || polygonOptions[0].label || 'Imported polygon',
        uploadedPolygonOptions: [],
        selectedUploadedPolygonIndex: null,
        btnNextDisabled: true
      }, () => {
        this.applyUploadedPolygonOption(polygonOptions[0], fileName);
      });
      return;
    }

    this.setState({
      polygonUploadError: '',
      uploadedPolygonName: fileName || 'Imported polygons',
      uploadedPolygonOptions: polygonOptions,
      selectedUploadedPolygonIndex: null,
      btnNextDisabled: true
    });
  }

  extractAllPolygonGeometries(payload) {
    if (!payload || typeof payload !== 'object') {
      return [];
    }

    const polygons = [];

    const buildLabel = (properties, fallback) => {
      if (properties) {
        const name =
          properties.name ||
          properties.Name ||
          properties.title ||
          properties.id ||
          properties.ID ||
          properties.Id;
        if (name) {
          return name;
        }
      }
      return fallback;
    };

    const pushPolygon = (coordinates, label, properties = {}) => {
      if (!Array.isArray(coordinates) || coordinates.length === 0) {
        throw new Error('The polygon geometry does not contain coordinates.');
      }
      polygons.push({
        geometry: {
          type: 'Polygon',
          coordinates
        },
        label,
        properties
      });
    };

    const handleGeometry = (geometry, properties = {}, fallbackLabel = 'Polygon') => {
      if (!geometry || !geometry.type) {
        return;
      }
      const baseLabel = buildLabel(properties, fallbackLabel);
      if (geometry.type === 'Polygon') {
        pushPolygon(geometry.coordinates, baseLabel, properties);
      } else if (geometry.type === 'MultiPolygon') {
        if (!Array.isArray(geometry.coordinates) || geometry.coordinates.length === 0) {
          throw new Error('The MultiPolygon geometry does not contain coordinates.');
        }
        geometry.coordinates.forEach((coords, index) => {
          pushPolygon(coords, `${baseLabel} (part ${index + 1})`, properties);
        });
      }
    };

    if (payload.type === 'FeatureCollection' && Array.isArray(payload.features)) {
      payload.features.forEach((feature, index) => {
        if (feature && feature.geometry && (feature.geometry.type === 'Polygon' || feature.geometry.type === 'MultiPolygon')) {
          handleGeometry(feature.geometry, feature.properties || {}, `Polygon ${index + 1}`);
        }
      });
    } else if (payload.type === 'Feature') {
      handleGeometry(payload.geometry, payload.properties || {});
    } else if (payload.type === 'Polygon' || payload.type === 'MultiPolygon') {
      handleGeometry(payload, {});
    } else {
      throw new Error('Unsupported GeoJSON type. Please upload a GeoJSON Feature, FeatureCollection, Polygon, or MultiPolygon.');
    }

    return polygons;
  }

  handleUploadedPolygonSelection(option) {
    if (option === null) {
      this.setState({ selectedUploadedPolygonIndex: null });
      return;
    }
    const optionIndex = option.value;
    const polygonOption = Array.isArray(this.state.uploadedPolygonOptions)
      ? this.state.uploadedPolygonOptions[optionIndex]
      : null;
    if (!polygonOption) {
      return;
    }
    this.applyUploadedPolygonOption(polygonOption, `${this.state.uploadedPolygonName || 'Imported polygon'} - ${polygonOption.label || `Polygon ${optionIndex + 1}`}`);
    this.setState({ selectedUploadedPolygonIndex: optionIndex });
  }

  applyUploadedPolygonOption(polygonOption, displayLabel) {
    if (!polygonOption || !polygonOption.geometry) {
      return;
    }

    const feature = {
      type: 'Feature',
      properties: polygonOption.properties || {},
      geometry: polygonOption.geometry
    };

    draw.deleteAll();
    draw.add(feature);

    this.fitMapToGeometry(polygonOption.geometry);
    this.handlePolygonGeometryChange(feature);
    this.setState({
      polygonUploadError: '',
      uploadedPolygonName: displayLabel || polygonOption.label || 'Imported polygon',
      btnNextDisabled: true
    });
  }

  fitMapToGeometry(geometry) {
    if (!geometry) {
      return;
    }
    const mapInstance = this.state.mapita && typeof this.state.mapita.fitBounds === 'function'
      ? this.state.mapita
      : this.map;
    if (!mapInstance || typeof mapInstance.fitBounds !== 'function') {
      return;
    }

    const bounds = this.calculateBoundsFromCoordinates(geometry.coordinates);
    if (!bounds) {
      return;
    }

    mapInstance.fitBounds(bounds, {
      padding: 60,
      maxZoom: 16,
      duration: 500
    });
  }

  calculateBoundsFromCoordinates(coordinates) {
    if (!Array.isArray(coordinates)) {
      return null;
    }

    let minLng = Infinity;
    let minLat = Infinity;
    let maxLng = -Infinity;
    let maxLat = -Infinity;

    const traverse = (coords) => {
      if (!Array.isArray(coords)) {
        return;
      }
      if (typeof coords[0] === 'number' && typeof coords[1] === 'number') {
        const [lng, lat] = coords;
        if (Number.isFinite(lng) && Number.isFinite(lat)) {
          minLng = Math.min(minLng, lng);
          minLat = Math.min(minLat, lat);
          maxLng = Math.max(maxLng, lng);
          maxLat = Math.max(maxLat, lat);
        }
        return;
      }
      coords.forEach(traverse);
    };

    traverse(coordinates);

    if (!Number.isFinite(minLng) || !Number.isFinite(minLat) || !Number.isFinite(maxLng) || !Number.isFinite(maxLat)) {
      return null;
    }

    return new mapboxgl.LngLatBounds([minLng, minLat], [maxLng, maxLat]);
  }

  handlePolygonGeometryChange(feature, mapInstance = null) {
    if (!feature || !feature.geometry) {
      return;
    }

    const mapRef = mapInstance || this.state.mapita || this.map;
    const body = {
      geometry: feature.geometry
    };

    fetch(URL_BACK + 'sbb_cockpit/tiles_intersecting_polygon', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(body)
    }).then((res) => res.json())
      .then((json) => {
        const tileIds = Array.isArray(json.features)
          ? json.features
            .map(featureItem => featureItem && featureItem.properties ? featureItem.properties.tileId : null)
            .filter((tileId) => tileId !== null && typeof tileId !== 'undefined')
          : [];
        this.setState({ origin_geojson: feature, tile_list: tileIds });
        const polygonSource = mapRef && mapRef.getSource ? mapRef.getSource('data-tiles-polygon') : null;
        if (polygonSource && typeof polygonSource.setData === 'function') {
          polygonSource.setData(json);
        }

        return fetch(URL_BACK + 'sbb_cockpit/total_trips_n_employees_in_polygon', {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(body)
        }).then((res) => res.json())
          .then((totals) => {
            this.setState({ polygon_trips: totals.trips, polygon_employees: totals.employees });
            this.checkerTripsVsEmployees(totals.trips, totals.employees);
            return fetch(URL_BACK + 'sbb_cockpit/employers_around_polygon', {
              method: 'POST',
              headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(body)
            }).then((res) => res.json())
              .then((employers) => {
                const reliValues = Array.isArray(employers.features)
                  ? employers.features
                    .filter(featureItem => featureItem && featureItem.properties && featureItem.properties.inside === 1)
                    .map(featureItem => featureItem.properties.RELI)
                  : [];
                this.setState({ RELIS: reliValues });
                const employersSource = mapRef && mapRef.getSource ? mapRef.getSource('point_employers') : null;
                if (employersSource && typeof employersSource.setData === 'function') {
                  employersSource.setData(employers);
                }
              });
          });
      });
  }

  btnPrevious() {
    if (this.state.current_step !== 0) {
      let new_step = this.state.current_step - 1;
      this.setState({ current_step: new_step })
    }

  }

  checkerTripsVsEmployees(trips, employees) {
    if (trips < employees) {
      this.setState({ checkerTripsEmployees: true, btnNextDisabled: true })
    } else {
      this.setState({ checkerTripsEmployees: false, btnNextDisabled: false })
    }
  }

  btnAveragePoint() {
    fetch(URL_BACK + 'sbb_cockpit/upload_hyperparameters ', {
      method: 'PATCH',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        unique_id: this.state.unique_id,
        start_point: point_geojson.features[0].geometry.coordinates
      })
    })
      .then((res) => res.json())
      .then((json) => {
        this.setState({ btnNextDisabled: true })
      })
  }

  btnContinue() {
    if (this.state.current_step !== 6) {
      if (this.state.current_step === 3) {
        this.savePolygonInDB();
      }
      if (this.state.current_step === 5) {
        this.btnAveragePoint();
      }
      if (this.state.current_step >= 4) {
        this.setState({ btnPreviousDisabled: false });
      }
      let new_step = this.state.current_step + 1;
      this.setState({ current_step: new_step, btnNextDisabled: true, btnPreviousDisabled: false })
    }
  }

  btnNoCommutingFactor() {
    this.setState({ enable_commuting_factor_options: true })
  }

  btnYesCommutingFactor() {
    fetch(URL_BACK + 'sbb_cockpit/upload_hyperparameters', {
      method: 'PATCH',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        unique_id: this.state.unique_id,
        commuting_factor: this.state.commuting_factor
      })
    })
      .then((res) => res.json())
      .then((json) => {
        this.btnContinue();
      })
  }

  savePolygonInDB() {
    fetch(URL_BACK + 'sbb_cockpit/upload_hyperparameters', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        properties: {
          name: this.state.selectedCompanySite.value,
          tiles_list: this.state.tile_list,
          company: this.state.selectedCompanyName.value,
          site_type: this.state.selectedCompanyType[0].value,
          RELIS: this.state.RELIS,
        },
        geometry: this.state.origin_geojson.geometry
      })
    })
      .then((res) => res.json())
      .then((json) => {
        this.setState({ unique_id: json.unique_id })
        return json;
      })
      .then((json) => {
        fetch(URL_BACK + 'sbb_cockpit/upload_hyperparameters', {
          method: 'PATCH',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            unique_id: json.unique_id,
            start_date: "2024-11-01T00:00:00.000+00:00",
            end_date: "2024-11-30T23:59:00.000+00:00",
          })
        }).then((res) => res.json())
          .then((json) => {
            fetch(URL_BACK + 'sbb_cockpit/compute_commuting_factor/' + json.unique_id, {
              method: 'GET',
              headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
              }
            }).then((res) => res.json())
              .then((json) => {
                this.setState({ commuting_factor: json.commuting_factor, loading_state_commuterfactor: false })
              })
          })
      })
  }

  radioTilesCommutingFactor(event) {
    this.setState({ change_commuting_factor: event });
    if (event === 'swiss_average') {
      fetch(URL_BACK + 'sbb_cockpit/upload_hyperparameters', {
        method: 'PATCH',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          unique_id: this.state.unique_id,
          average_commuter_factor: true
        })
      }).then((res) => res.json())
        .then((json) => {
          this.btnContinue();
        })
    }
  }

  btnConfirmProcess() {
    fetch(URL_BACK + 'sbb_cockpit/upload_hyperparameters', {
      method: 'PATCH',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        unique_id: this.state.unique_id,
        compute: true
      })
    }).then((res) => res.json())
      .then(() => {
        this.setState({ completeProcess: true })
      })
  }


  bufferPolygon(event) {
    console.log(event)
    this.setState({ buffer_factor: event });
    this.state.mapita.getSource("data-tiles-polygon").setData(URL_BACK + 'sbb_cockpit/100m_heatmap_tiles/' + this.state.unique_id + '/' + event);
  }

  btnBufferAnalysis() {
    this.setState({ change_commuting_factor: '', loading_state_commuterfactor: true, enable_commuting_factor_options: false })

    fetch(URL_BACK + 'sbb_cockpit/upload_hyperparameters', {
      method: 'PATCH',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        unique_id: this.state.unique_id,
        buffer_factor: parseFloat(this.state.buffer_factor)
      })
    }).then((res) => res.json())
      .then((json) => {
        fetch(URL_BACK + 'sbb_cockpit/compute_commuting_factor/' + this.state.unique_id, {
          method: 'GET',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          }
        }).then((res) => res.json())
          .then((json) => {
            fetch(URL_BACK + 'sbb_cockpit/upload_hyperparameters', {
              method: 'PATCH',
              headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                unique_id: this.state.unique_id,
                commuting_factor: json.commuting_factor
              })
            })
            this.setState({ commuting_factor: json.commuting_factor, loading_state_commuterfactor: false })
          })
      })
  }

  btnCalendarCommuting() {
    this.setState({ change_commuting_factor: '', loading_state_commuterfactor: true, enable_commuting_factor_options: false })
    fetch(URL_BACK + 'sbb_cockpit/upload_hyperparameters', {
      method: 'PATCH',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        unique_id: this.state.unique_id,
        start_date: this.state.calendar_commuting_factor[0],
        end_date: this.state.calendar_commuting_factor[1]
      })
    }).then((res) => res.json())
      .then((json) => {
        fetch(URL_BACK + 'sbb_cockpit/compute_commuting_factor/' + this.state.unique_id, {
          method: 'GET',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          }
        }).then((res) => res.json())
          .then((json) => {
            fetch(URL_BACK + 'sbb_cockpit/upload_hyperparameters', {
              method: 'PATCH',
              headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                unique_id: this.state.unique_id,
                commuting_factor: json.commuting_factor
              })
            })
            this.setState({ commuting_factor: json.commuting_factor, loading_state_commuterfactor: false })
          })
      })
  }

  calendarCommutingFactor(event) {
    this.setState({ calendar_commuting_factor: event });
  }

  btnDashboard(){
    window.open(URL_FRONT + 'b2b', "_blank", "noreferrer");
  }

  render() {

    const polygonSelectOptions = (this.state.uploadedPolygonOptions || []).map((option, index) => ({
      value: index,
      label: option.label || `Polygon ${index + 1}`
    }));
    const selectedPolygonOption = typeof this.state.selectedUploadedPolygonIndex === 'number'
      ? polygonSelectOptions.find(option => option.value === this.state.selectedUploadedPolygonIndex)
      : null;

    return (
      <>

        <Drawer placement={'right'} size={'md'}>
        </Drawer>
        <Container style={{ height: '100vh', overflow: 'hidden' }}>
          {/* Header */}
          <Header className="page-header">
            <NavBarComponent />
          </Header>

          {/* Content */}
          <Content style={{ height: 'calc(100% - 60px)', overflow: 'hidden' }}>
            <Grid fluid style={{ height: '100%' }}>
              <Row style={{ height: '100%' }}>
                <Col xs={0} md={4} style={{
                  backgroundColor: 'white',
                  padding: '15px',
                  height: '100%',
                  overflowY: 'auto', // Enable scrolling here
                }}>
                  <Steps current={this.state.current_step} vertical style={{
                    width: '150px',
                    display: 'inline-table',
                    verticalAlign: 'top'
                  }}>
                    <Steps.Item title="Company Name" />
                    <Steps.Item title="Location Name" />
                    <Steps.Item title="Company Type" />
                    <Steps.Item title="Draw Polygon Area" />
                    <Steps.Item title="Commuting Factor" />
                    <Steps.Item title="Arrival (Initial) Point" />
                    {/* <Steps.Item title="ÖV Quality Validation" /> */}
                    <Steps.Item title="Start Calculation" />

                  </Steps>
                </Col>
                <Col xs={24} md={8} style={{
                  backgroundColor: 'white',
                  padding: '15px',
                  height: '100%',
                  overflowY: 'auto', // Enable scrolling here
                }}>
                  <Heading level={2}>Upload Data - B2B Analysis</Heading>
                  <Text>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed sed diam in metus faucibus feugiat ut eget justo. Ut auctor, diam et molestie aliquet, sem dolor vehicula ante, vitae luctus lacus risus vitae eros. Sed elementum odio turpis, sit amet finibus nulla dapibus nec. Aenean iaculis semper odio, sed accumsan tellus accumsan a. </Text>
                  <hr />
                  {/* Step 0 - Company Name */}
                  {
                    this.state.current_step === 0 ?
                      <div style={{ paddingBottom: '30px' }}>
                        <Heading level={3}>Company Name</Heading>
                        <Text style={{ marginBottom: '8px' }}>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</Text>
                        <CreatableSelect isClearable options={this.state.companyNamesList} onChange={this.handleCompanyName.bind(this)} value={this.state.selectedCompanyName} />
                      </div>
                      :
                      <></>
                  }

                  {/* Step 1 - Site Name */}
                  {
                    this.state.current_step === 1 ?
                      <div style={{ paddingBottom: '30px' }}>
                        <Heading level={3}>Location (Site) Name</Heading>
                        <Text style={{ marginBottom: '8px' }}>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</Text>
                        <CreatableSelect isClearable options={this.state.companySitesList} onChange={this.handleCompanySite.bind(this)} value={this.state.selectedCompanySite} />
                      </div>
                      :
                      <></>
                  }

                  {/* Step 2 - Company Type */}
                  {
                    this.state.current_step === 2 ?
                      <div style={{ paddingBottom: '30px' }}>
                        <Heading level={3}>Company Type</Heading>
                        <Text style={{ marginBottom: '8px' }}>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</Text>
                        <Select isMulti options={this.state.companyTypesList} onChange={this.handleCompanyType.bind(this)} value={this.state.selectedCompanyType} />
                      </div>
                      :
                      <></>
                  }

                  {/* Step 3 - Draw Polygon */}
                  {
                    this.state.current_step === 3 ?
                      <div style={{ paddingBottom: '30px' }}>
                        <Heading level={3}>Draw Company Polygon</Heading>
                        <Text style={{ marginBottom: '8px' }}>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris dictum, odio a tempus vulputate, tortor est accumsan ante, non tristique nibh leo id lacus. Nulla tellus lorem, malesuada vitae iaculis nec, consectetur eu purus. Nulla semper lacinia felis, ac lacinia lorem commodo sit amet. Quisque id augue elit. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent eu dolor erat. Duis sed sem magna. Sed ut lectus nisi. Vivamus tincidunt tempus turpis et consequat.</Text>
                        <Text style={{ marginBottom: '8px' }}>Already have a polygon? Import a GeoJSON file to preload it, then refine the shape with the drawing tools before continuing.</Text>
                        <ButtonToolbar style={{ marginBottom: '10px' }}>
                          <Button size="sm" appearance="ghost" onClick={this.handlePolygonUploadClick.bind(this)}>
                            Upload GeoJSON Polygon
                          </Button>
                        </ButtonToolbar>
                        <input
                          type="file"
                          accept=".geojson,.json,application/geo+json,application/json"
                          ref={this.fileUploadRef}
                          style={{ display: 'none' }}
                          onChange={this.handlePolygonFileChange.bind(this)}
                        />
                        {
                          this.state.uploadedPolygonName ?
                            <Message type="success" showIcon centered style={{ marginBottom: '10px' }}>
                              <Text weight="medium">Loaded polygon: {this.state.uploadedPolygonName}. You can now adjust it directly on the map.</Text>
                            </Message>
                            :
                            <></>
                        }
                        {
                          this.state.polygonUploadError ?
                            <Message type="error" showIcon centered style={{ marginBottom: '10px' }}>
                              <Text weight="medium">{this.state.polygonUploadError}</Text>
                            </Message>
                            :
                            <></>
                        }
                        {
                          this.state.uploadedPolygonOptions.length > 1 ?
                            <div style={{ marginBottom: '10px' }}>
                              <Text style={{ marginBottom: '6px', display: 'block' }}>
                                Multiple polygons were found in {this.state.uploadedPolygonName || 'the uploaded file'}. Please select which one you want to edit.
                              </Text>
                              <Select
                                options={polygonSelectOptions}
                                value={selectedPolygonOption}
                                onChange={this.handleUploadedPolygonSelection.bind(this)}
                                placeholder="Select polygon to load"
                              />
                            </div>
                            :
                            <></>
                        }
                        <Panel className="panel-gradient-blue" shaded style={{ marginBottom: 20 }}>
                          <HeadingGroup align="left" style={{ marginBottom: 0 }}>
                            <Heading level={4} style={{ color: "white" }}>{numberWithCommas((this.state.polygon_employees).toFixed(0))}</Heading>
                            <Heading level={6} style={{ color: "white" }}>Employees within the Polygon</Heading>
                          </HeadingGroup>
                        </Panel>

                        <Panel className="panel-gradient-pink" shaded>
                          <HeadingGroup align="left" style={{ marginBottom: 0 }}>
                            <Heading level={4} style={{ color: "white" }}>{numberWithCommas((this.state.polygon_trips).toFixed(0))}</Heading>
                            <Heading level={6} style={{ color: "white" }}>Trips Daily within the Tile(s) selected</Heading>
                          </HeadingGroup>
                        </Panel>

                        {
                          this.state.checkerTripsEmployees ?
                            <>
                              <Message type="error" showIcon centered style={{ marginTop: '10px' }}>
                                <Text weight="medium">The number of trips within the tile(s) can't be less than the number of employees selected on the polygon area.</Text>
                              </Message>
                            </>
                            :
                            <></>
                        }
                      </div>
                      :
                      <></>
                  }

                  {/* Step 4 - Commuter Factor */}
                  {
                    this.state.current_step === 4 ?
                      <div style={{ paddingBottom: '30px' }}>
                        <Heading level={3}>Commuting Factor</Heading>
                        <Text style={{ marginBottom: '8px' }}>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris dictum, odio a tempus vulputate, tortor est accumsan ante, non tristique nibh leo id lacus. Nulla tellus lorem, malesuada vitae iaculis nec, consectetur eu purus. </Text>

                        {this.state.loading_state_commuterfactor ?
                          <>
                            <Message type="warning" centered style={{ marginTop: '10px' }}>

                              <Loader size="md" vertical inverse />
                              <Text weight="regular">We are calculating the commuter factor...</Text>
                              <Text weight="medium">This process could take a couple of minutes, please wait</Text>
                            </Message>
                          </>
                          :
                          <>
                            {
                              this.state.enable_commuting_factor_options ?
                                <>
                                  {
                                    this.state.change_commuting_factor === '' ?
                                      <>
                                        <RadioTileGroup aria-label="Visibility Level" onChange={this.radioTilesCommutingFactor.bind(this)}>
                                          <RadioTile icon={<Icon as={CalenderSimpleIcon} />} label="Change Dates" value="calendar">
                                            Change the starting date and end date of the analysis. Remember holidays can affect the commuting factor
                                          </RadioTile>
                                          <RadioTile icon={<Icon as={ResizeIcon} />} label="Polygon Adaptation" value="buffer">
                                            Expand or reduce your polygon size to adapt the commuter factor. Check for near-by-external influences, for example: another company, shopping mall, Migros/Coop...
                                          </RadioTile>

                                          <RadioTile icon={<Icon as={ScatterIcon} />} label="Swiss Average" value="swiss_average">
                                            Use the Switzerland's Average Commuting Factor of the companies
                                          </RadioTile>
                                        </RadioTileGroup>
                                      </>
                                      :
                                      <>
                                        {
                                          this.state.change_commuting_factor === 'buffer' ?
                                            <>
                                               <InputNumber style={{ marginBottom: '10px' }} value={this.state.buffer_factor} step={0.00001} max={0.2} min={-0.2} onChange={this.bufferPolygon.bind(this)}/>
                                              <Button size="sm" color="green" onClick={this.btnBufferAnalysis.bind(this)}>Re-Calculate</Button>
                                            </>
                                            :
                                            <>
                                              {
                                                this.state.change_commuting_factor === 'calendar' ?
                                                  <>
                                                    <VStack alignItems='center' justifyContent='center'>
                                                      <DateRangePicker format="dd.MM.yyyy" onChange={this.calendarCommutingFactor.bind(this)} showOneCalendar shouldDisableDate={combine(before(new Date("2022-09-01")), after(new Date("2022-12-31")))} value={this.state.calendar_commuting_factor} />
                                                      <Button size="sm" color="green" onClick={this.btnCalendarCommuting.bind(this)}>Re-Calculate</Button>
                                                    </VStack>
                                                  </>
                                                  :
                                                  <>
                                                  </>
                                              }
                                            </>
                                        }
                                      </>
                                  }

                                </>
                                :
                                <>
                                  <Panel className="panel-gradient-orange" shaded style={{ marginBottom: 20 }}>
                                    <HeadingGroup align="left" style={{ marginBottom: 0 }}>
                                      <Heading level={4} style={{ color: "white" }}>{(this.state.commuting_factor)?.toFixed(2)}</Heading>
                                      <Heading level={6} style={{ color: "white" }}> Factor</Heading>
                                    </HeadingGroup>
                                  </Panel>

                                  <Message showIcon type="warning" centered header="Is the commuter factor correct?">
                                    <p> Please verify the commuter factor presented above is aligned with the company work culture: shift workers, remote working...</p>
                                    <hr />
                                    <ButtonToolbar centered>
                                      <Button size="sm" onClick={this.btnNoCommutingFactor.bind(this)}>No</Button>
                                      <Button size="sm" onClick={this.btnYesCommutingFactor.bind(this)}>Yes</Button>
                                    </ButtonToolbar>
                                  </Message>
                                </>
                            }
                          </>
                        }

                      </div>
                      :
                      <></>
                  }

                  {/* Step 5 - Arrival Point */}
                  {
                    this.state.current_step === 5 ?
                      <div style={{ paddingBottom: '30px' }}>
                        <Heading level={3}>Arrival Point</Heading>
                        <Text style={{ marginBottom: '8px' }}>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</Text>
                      </div>
                      :
                      <></>
                  }


                  {/* Step 6 - Start Computation */}
                  {
                    this.state.current_step === 6 && !this.state.completeProcess ?
                      <div style={{ paddingBottom: '30px' }}>
                        <Heading level={3}>Confirm Computation</Heading>
                        <Text style={{ marginBottom: '8px' }}>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</Text>
                        <List size='sm' style={{ marginBottom: '8px' }}>
                          <List.Item key='companyName'>
                            <strong>Company Name:</strong> {(this.state.selectedCompanyName).value.toString()}
                          </List.Item>
                          <List.Item key='companySite'>
                            <strong>Company Site:</strong> {(this.state.selectedCompanySite).value.toString()}
                          </List.Item>
                          <List.Item key='companyType'>
                            <strong>Company Type:</strong> {(this.state.selectedCompanyType[0]).value.toString()}
                          </List.Item>
                          <List.Item key='commutingFactor'>
                            <strong>Commuting Factor:</strong> {(this.state.commuting_factor).toFixed(3)}
                          </List.Item>
                        </List>

                        <Button color="green" appearance="primary" onClick={this.btnConfirmProcess.bind(this)}>
                          I confirm that is correct
                        </Button>
                      </div>
                      :
                      <></>
                  }

                  {/* Process Complete */}
                  {
                    this.state.current_step === 6 && this.state.completeProcess ?
                      <div style={{ paddingBottom: '30px' }}>
                        <Heading level={3}>We are calculating your building!</Heading>
                        <Text style={{ marginBottom: '8px' }}>This process might take a few more minutes. 
                          Once it is complete, the company will appear on the main dashboard.</Text>
                        <Button color="green" appearance="primary" endIcon={<FaExternalLinkSquareAlt />} onClick={this.btnDashboard.bind(this)}>
                          Go to dashboard
                        </Button>
                      </div>
                      :
                      <></>
                  }

                  <hr />
                  {
                    this.state.current_step !== 4 && this.state.current_step !== 6 ?
                      <>
                        <ButtonToolbar>
                          <Button onClick={this.btnPrevious.bind(this)} disabled={this.state.btnPreviousDisabled}>
                            Previous
                          </Button>
                          <Button onClick={this.btnContinue.bind(this)} color="green" appearance="primary" disabled={this.state.btnNextDisabled}>
                            Continue
                          </Button>
                        </ButtonToolbar>
                      </>
                      :
                      <>
                      </>
                  }

                </Col>
                <Col xs={24} md={12} style={{
                  backgroundColor: 'white',
                  padding: '15px',
                  height: '100%',
                }}>
                  <div
                    ref={this.mapContainer}
                    style={{
                      width: '100%',
                      height: '100%',
                      backgroundColor: 'lightgrey'
                    }}
                  />

                </Col>
              </Row>
            </Grid>
          </Content>

        </Container>
      </>
    )
  }
}

export default BusinessCockpitUpload;
